import request, { basicRequest } from '@/utils/request'

import { UserInfo } from '@/types/user'

interface LoginResponse {
  access_token: string
  refresh_token: string
}

export function Login(
  user: string,
  password: string,
  rememberMe: boolean
): Promise<LoginResponse> {
  return request.post('/login', {
    user,
    password,
    rememberMe,
  })
}

// eslint-disable-next-line
export function Logout(): Promise<any> {
  return request({
    url: '/logout',
  })
}

// eslint-disable-next-line
export function GetInfo(): Promise<UserInfo> {
  return request.get('/me')
}

export function RefreshToken(
  refreshToken: string
): Promise<{ data: LoginResponse; code: number }> {
  return basicRequest.post('/refresh-token', null, {
    headers: { Authorization: 'Bearer ' + refreshToken },
  })
}
